var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ActionModelV5, ActionServiceV5 } from '.';
import { App } from '../../Application';
import { PendingActionWorker } from '../../Application/DeltaWorkers/PendingActionWorker';
import { Constants, Resolve } from '../../Contract';
import { ChangeNotifier } from '../../Core';
import { Commands } from '../../UI/Command';
import { DirtyCacheV5, ModelFactoryV5, ModelResolverV5 } from '../Core';
import { BuildStyleBehavior, EventBehavior, ReferenceBehavior, StyleBehavior } from '../Core/Behaviors';
import { ModelCollectionV5 } from '../Core/ModelCollection';
import { RequestBuilderV5, UrlResolverV5 } from '../Server';
import { ViewManagerV5 } from '../UI';
import { ArrangeWindowCommandV5, BringToFront, ChangeMenuV5, GridPrintCommand, ModalExecutionCommand, OpenViewV5, StylesChangedCommand, UpdateRangesCommand } from '../UI/Command';
import { ChangeFocusControlV5 } from '../UI/Command/ChangeFocusControlV5';
import { PrintFileCommand } from '../UI/Command/DesktopAgent/PrintFileCommand';
import { ShowClientPrintersCommand } from '../UI/Command/DesktopAgent/ShowClientPrintersCommand';
import { DisposeWindowCommandV5 } from '../UI/Command/DisposeWindowCommandV5';
import { DownloadFileCommand } from '../UI/Command/DownloadFile';
import { OpenExternalLinkCommandV5 } from '../UI/Command/OpenExternalLinkCommandV5';
import { SetTextToDataManagerCommandV5 } from '../UI/Command/SetTextToDataManagerCommandV5';
import { StartEditV5 } from '../UI/Command/StartEditV5';
import { ActionWorker, ModelWorker, VisualWorker } from './DeltaWorkers';
var AppV5 = (function (_super) {
    __extends(AppV5, _super);
    function AppV5(inject) {
        if (inject === void 0) { inject = null; }
        return _super.call(this, inject) || this;
    }
    AppV5.prototype.init = function (controller, action, callback, appname, requestConfig, queryString) {
        if (controller === void 0) { controller = ''; }
        if (action === void 0) { action = ''; }
        this.register();
        this.initResolve();
        this.loadInitialState(controller, action, callback, appname, requestConfig, queryString);
    };
    AppV5.prototype.loadInitialState = function (controller, action, callback, appname, requestConfig, queryString) {
        var _this = this;
        var parameters = appname ? [{ applicationName: appname }] : null;
        var actionModel = new ActionModelV5(controller, action, '', '', parameters, function () { return _this.afterInit(callback); }, false, queryString);
        actionModel.requestConfig = requestConfig == null ? actionModel.requestConfig : requestConfig;
        this.action.send(actionModel);
    };
    AppV5.prototype.register = function () {
        _super.prototype.register.call(this);
        this.inject.register(Constants.UrlResolver, UrlResolverV5, Resolve.Singleton);
        this.inject.register(Constants.RequestBuilder, RequestBuilderV5, Resolve.Singleton);
        this.inject.register(Constants.Action, ActionServiceV5, Resolve.Singleton);
        this.inject.register(Constants.NotifyBuffer, DirtyCacheV5, Resolve.Singleton);
        this.inject.register(Constants.ModelFactory, ModelFactoryV5, Resolve.Singleton);
        this.inject.register(Constants.ModelResolver, ModelResolverV5, Resolve.Singleton);
        this.inject.register(Constants.ViewManager, ViewManagerV5, Resolve.Singleton);
        this.inject.register(Constants.Buffer, ModelCollectionV5, Resolve.Request);
        this.executeOnRegister();
    };
    AppV5.prototype.modelResolverInit = function () {
        this.modelResolver.registerBehavior(new StyleBehavior());
        this.modelResolver.registerBehavior(new EventBehavior());
        this.modelResolver.registerBehavior(new ReferenceBehavior());
        this.modelResolver.registerNotifier(new ChangeNotifier());
        this.modelResolver.registerBehavior(new BuildStyleBehavior());
    };
    AppV5.prototype.deltaHandlerInit = function () {
        this.deltaHandler.registerWorker(new ModelWorker());
        this.deltaHandler.registerWorker(new ActionWorker());
        this.deltaHandler.registerWorker(new VisualWorker());
        this.deltaHandler.registerWorker(new PendingActionWorker());
        this.executeDeltaHandler();
    };
    AppV5.prototype.executeOnCommandRegister = function () {
        _super.prototype.executeOnCommandRegister.call(this);
        this.commandFactory.register(Commands.OpenView, OpenViewV5);
        this.commandFactory.register(Commands.ChangeMenuCommand, ChangeMenuV5);
        this.commandFactory.register(Commands.DisposeWindowCommand, DisposeWindowCommandV5);
        this.commandFactory.register(Commands.BringToFrontCommand, BringToFront);
        this.commandFactory.register(Commands.SetTextToDataManagerCommand, SetTextToDataManagerCommandV5);
        this.commandFactory.register(Commands.ChangeFocusControlCommand, ChangeFocusControlV5);
        this.commandFactory.register(Commands.OpenExternalLinkCommand, OpenExternalLinkCommandV5);
        this.commandFactory.register(Commands.DownloadFileCommand, DownloadFileCommand);
        this.commandFactory.register(Commands.ArrangeWindowCommand, ArrangeWindowCommandV5);
        this.commandFactory.register(Commands.GridPrintCommand, GridPrintCommand);
        this.commandFactory.register(Commands.StartEditCommand, StartEditV5);
        this.commandFactory.register(Commands.StylesChangedCommand, StylesChangedCommand);
        this.commandFactory.register(Commands.UpdateRangesCommand, UpdateRangesCommand);
        this.commandFactory.register(Commands.ModalExecutionCommand, ModalExecutionCommand);
        this.commandFactory.register(Commands.ShowClientPrintersCommand, ShowClientPrintersCommand);
        this.commandFactory.register(Commands.PrintFileCommand, PrintFileCommand);
        if (this.onCommandRegister) {
            this.onCommandRegister(this.commandFactory);
        }
    };
    return AppV5;
}(App));
export { AppV5 };
